import React from 'react';
import LandingPage from './pages/LandingPage';

const App: React.FC = () => {
  return <LandingPage />;
};

export default App;
